import React from 'react';
import { Button, Table } from 'react-bootstrap';
import { CategoryDeleteButton } from '../Machining/CategoryDeleteButton';

export function CategoryTable({ categories, machines, saving, onAdd, onEdit, onDelete }) {
    const count = category => machines.filter(machine => String(machine.category) === String(category.category)).length;

    return (
        <>
            <div className="d-flex flex-wrap align-items-center justify-content-between mb-3 gap-2">
                <h5 className="mb-0">Categories</h5>
                <Button disabled={saving} onClick={onAdd}>Add category</Button>
            </div>
            <Table responsive striped hover className="align-middle mb-0">
                <thead><tr><th>Category ID</th><th>Description</th><th>Machines</th><th>Actions</th></tr></thead>
                <tbody>
                    {categories.length === 0 && <tr><td colSpan={4} className="text-center text-muted py-4">No categories yet. Add a category before adding machines.</td></tr>}
                    {categories.map(category => <tr key={category.id}>
                        <td>{category.category ?? '—'}</td><td>{category.description}</td><td>{count(category)}</td>
                        <td>
                            <div className="d-flex align-items-start gap-2">
                                <Button
                                    size="sm"
                                    variant="outline-primary"
                                    disabled={saving || category.id === 'pending'}
                                    aria-label={`Edit category ${category.description}`}
                                    onClick={() => onEdit(category)}
                                >
                                    Edit
                                </Button>
                                <CategoryDeleteButton category={category} saving={saving} onDelete={onDelete} />
                            </div>
                        </td>
                    </tr>)}
                </tbody>
            </Table>
        </>
    );
}
